import { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { updateCertificationCoverImage } from '../../actions/certificationActions'
import { showGenericError } from '../../utility/certificationBuilder'
import BuilderField from './BuilderField'

import classes from './CoverImageField.module.scss'

const CoverImageField = ({ certification }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const fileInput = useRef(null)
  const [isSaving, setIsSaving] = useState(false)
  const [preview, setPreview] = useState(null)

  const imageUrl = preview || (!isSaving && certification.coverImage?.largeFileUrl)

  const save = (photo) => {
    const previewUrl = photo && URL.createObjectURL(photo)

    setIsSaving(true)
    setPreview(previewUrl)
    dispatch(updateCertificationCoverImage({ id: certification.id, photo })).unwrap()
      .catch(showGenericError)
      .finally(() => {
        if (previewUrl) { URL.revokeObjectURL(previewUrl) }
        if (fileInput.current) { fileInput.current.value = '' }
        setIsSaving(false)
        setPreview(null)
      })
  }

  return (
    <BuilderField label={t('certificationBuilder.details.coverImage')} htmlFor='certificationCoverImage'>
      <div className={classNames('position-relative', classes.tile)}>
        {imageUrl && <img src={imageUrl} alt='' className={classes.image} />}
        {isSaving && (
          <span className={classNames('d-flex align-items-center justify-content-center', classes.spinner)}>
            <i className='fa fa-spinner fa-spin' aria-hidden='true' />
          </span>
        )}
        <input
          ref={fileInput}
          id='certificationCoverImage'
          type='file'
          accept='image/*'
          className='d-none'
          onChange={(e) => e.target.files[0] && save(e.target.files[0])}
        />
        <div className={classNames('d-flex', classes.actions)}>
          <button type='button' className={classes.pill} onClick={() => fileInput.current.click()} disabled={isSaving}>
            {t(certification.coverImage ? 'certificationBuilder.details.replaceCover' : 'certificationBuilder.details.uploadCover')}
          </button>
          {certification.coverImage && (
            <button type='button' className={classes.pill} onClick={() => save(null)} disabled={isSaving}>
              {t('common.action.remove')}
            </button>
          )}
        </div>
      </div>
    </BuilderField>
  )
}

CoverImageField.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    coverImage: PropTypes.shape({ largeFileUrl: PropTypes.string }),
  }).isRequired,
}

export default CoverImageField
